import React, { memo } from 'react';
import { IconProps } from '.';

type TimesIconProps = {
  color?: string;
} & IconProps;

export const TimesIcon: React.FC<TimesIconProps> = memo(
  ({ width = 24, height = 24, className }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 21 22"
        className={className}
      >
        <path
          stroke="currentColor"
          strokeWidth="1.5"
          d="M1.47 20.47L20.47 1.47"
        ></path>
        <path
          stroke="currentColor"
          strokeWidth="1.5"
          d="M20.47 20.53L1.47 1.53"
        ></path>
      </svg>
    );
  }
);
